"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHotel = function SvgHotel(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.89 9.756C21.675 9.771 22 10.82 22 13.326v7.742c0 .51-.412.924-.924.924h-1.567c-.632 0-.944-.462-1.184-.97a2.688 2.688 0 0 0-2.413-1.53h-7.79a2.688 2.688 0 0 0-2.412 1.53c-.238.508-.55.97-1.184.97H2.924A.925.925 0 0 1 2 21.068v-7.742c0-2.508.107-3.555 9.89-3.57.072 0-.072 0 0 0Zm8.254-4.651c0-2.196 0-3.105-8.141-3.105-8.142 0-8.144.909-8.144 3.105v3.038c0 .404.374.711.774.627.287-.06.62-.115.947-.163a.629.629 0 0 0 .547-.632V6.236c0-.51.415-.924.924-.924h3.085c.51 0 .925.415.925.924V7.73c0 .303.245.547.55.545h.737a.553.553 0 0 0 .529-.387l.552-1.769a.926.926 0 0 1 1.149-.61l2.863.862c.744.233.957.722.704 1.444a.64.64 0 0 0 .512.82c.248.04.483.085.7.132a.643.643 0 0 0 .784-.624V5.105h.003Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHotel);
var _default = exports["default"] = Memo;